import types from './appTypes';

const initialState = {
    user: {},
    sideNavOpenState: null,
    showUpgradeModal: false,
    showStartPlanModal: false,
};

export default (state = initialState, action) => {
    switch (action.type) {
        case types.SET_USER: {
            return {
                ...state,
                user: { ...action.payload },
            };
        }
        case types.REVOKE_ACCESS: {
            return {
                ...state,
                user: {},
            };
        }
        case types.SET_ACTIVE_CLIENT: {
            return {
                ...state,
                user: {
                    ...state.user,
                    activeClient: { ...action.payload },
                },
            };
        }
        case types.SET_SIDE_NAV_PINNED: {
            return {
                ...state,
                sideNavPinnedState: action.payload,
            };
        }
        case types.SHOW_READY_UPGRADE_MODAL: {
            return {
                ...state,
                showUpgradeModal: action.payload,
            };
        }
        case types.SHOW_START_PLAN_MODAL: {
            return {
                ...state,
                showStartPlanModal: action.payload,
            };
        }
        default:
            return state;
    }
};
